import React from 'react'
import ConfiguracoesAvaliacoes from '../../../components/performance/ConfiguracoesAvaliacoes'

export default function ConfiguracoesPage() {
  return (
    
            <ConfiguracoesAvaliacoes />
          
  )
}
